// Shopify EUR->BGN Currency Converter by RIZN v.7 (EUR to BGN only)
(function () {
  'use strict';

  if (window.EurBgnConverterShopifyInitialized) return;
  window.EurBgnConverterShopifyInitialized = true;

  // Constants
  const EUR_FACTOR = 1.95583;

  const TEXT_NODES_TO_CHECK = [
    'span','b','p','strong','div','li','a','option','del','sup','sub','sale-price','compare-at-price'
  ];
  const OTHER_NODES_TO_CHECK = [
    'div','dd','td','ul','span','p','s','del','sup','sub','sale-price','compare-at-price'
  ];

  // EUR patterns (EUR to BGN only)
  const EUR_PATTERNS = [
    // € 1.234,56   or  €1.234,56
    { regex: /((€|EUR|eur)\s*([0-9.]+,[0-9]{2}))/, priceIndex: 3, decimalSeparator: ',', thousandSeparator: '.', currency: 'EUR' },
    // € 1,234.56
    { regex: /((€|EUR|eur)\s*([0-9,]+\.[0-9]{2}))/, priceIndex: 3, decimalSeparator: '.', thousandSeparator: ',', currency: 'EUR' },
    // € 1234 or € 1.234 or € 1,234
    { regex: /((€|EUR|eur)\s*([0-9][0-9.]*))/, priceIndex: 3, thousandSeparator: '.', currency: 'EUR' },
    { regex: /((€|EUR|eur)\s*([0-9][0-9,]*))/, priceIndex: 3, thousandSeparator: ',', currency: 'EUR' },

    // 1.234,56 €   or  1.234,56 EUR
    { regex: /(([-|+]?[0-9.]+,[0-9]{2})\s*(€|EUR|eur))/, priceIndex: 2, decimalSeparator: ',', thousandSeparator: '.', currency: 'EUR' },
    // 1,234.56 €
    { regex: /(([-|+]?[0-9,]+\.[0-9]{2})\s*(€|EUR|eur))/, priceIndex: 2, decimalSeparator: '.', thousandSeparator: ',', currency: 'EUR' },
    // 1234 €
    { regex: /(([-|+]?[0-9][0-9.]*)\s*(€|EUR|eur))/, priceIndex: 2, thousandSeparator: '.', currency: 'EUR' },
    { regex: /(([-|+]?[0-9][0-9,]*)\s*(€|EUR|eur))/, priceIndex: 2, thousandSeparator: ',', currency: 'EUR' },

    // ( 1,234.56 € )
    { regex: /((\([-|+]?\s*[0-9,]+\.[0-9]{2})\s*(€|EUR|eur)\))/, priceIndex: 2, thousandSeparator: ',', currency: 'EUR' },
    { regex: /\(\s*([+-])?\s*([\d,]+\.\d{2})\s*(€|EUR|eur)\s*\)/, priceIndex: 2, thousandSeparator: ',', currency: 'EUR' }
  ];

  function escapeRegexDot(s) {
    return s === '.' ? '\\.' : s;
  }

  function format(amount, decimalSeparator = ',', thousandSeparator = '.') {
    let formattedAmount = amount;
    if (decimalSeparator === ',') {
      formattedAmount = formattedAmount.replace('.', ',');
    }
    if (thousandSeparator) {
      formattedAmount = formattedAmount.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    }
    return formattedAmount;
  }

  function convertToBgn(number) {
    return (number * EUR_FACTOR).toFixed(2);
  }

  function matchPrice(text) {
    // Skip already converted text that includes both EUR and BGN
    if (
      (text.includes('€') && (text.includes('лв') || text.includes('BGN') || text.includes('bgn'))) ||
      (text.includes('EUR') && (text.includes('лв') || text.includes('BGN') || text.includes('bgn')))
    ) {
      return null;
    }

    let bestMatchLength = 0;
    let number;
    let regex;
    let resultText = '';
    let currentText = text;

    do {
      EUR_PATTERNS.forEach(listRegex => {
        const match = currentText.match(listRegex.regex);

        if (match && match[0].length > bestMatchLength) {
          bestMatchLength = match[0].length;
          let cleanedString = match[listRegex.priceIndex];

          // Clean brackets/signs/spaces/currency symbols
          cleanedString = cleanedString
            .replaceAll('(', '')
            .replaceAll(')', '')
            .replaceAll('-', '')
            .replaceAll('+', '')
            .replaceAll(' ', '')
            .replaceAll('€', '')
            .replaceAll('EUR', '')
            .replaceAll('eur', '');

          if (listRegex.thousandSeparator) {
            cleanedString = cleanedString.replace(new RegExp(escapeRegexDot(listRegex.thousandSeparator), 'g'), '');
          }
          if (listRegex.decimalSeparator && listRegex.decimalSeparator === ',') {
            cleanedString = cleanedString.replace(new RegExp(escapeRegexDot(listRegex.decimalSeparator), 'g'), '.');
          }

          number = parseFloat(cleanedString);
          regex = listRegex;
        }
      });

      if (bestMatchLength !== 0 && !Number.isNaN(number)) {
        const newValue = format(
          convertToBgn(number),
          regex.decimalSeparator,
          regex.thousandSeparator
        );

        const suffix = ' лв';

        const updatedText = currentText.replace(regex.regex, (match, p1) => {
          return p1 + ' (' + newValue + suffix + ')';
        });

        const lastChangedCharIndex =
          updatedText.indexOf(newValue + suffix + ')') + (newValue + suffix + ')').length;

        resultText += updatedText.substring(0, lastChangedCharIndex);
        currentText = updatedText.substring(lastChangedCharIndex);

        regex = null;
        number = null;
        bestMatchLength = 0;
      } else {
        resultText += currentText;
        currentText = '';
      }
    } while (currentText.length > 0);

    return resultText;
  }

  function replacePrice(node) {
    const result = matchPrice(node.textContent);
    if (result && result !== node.textContent) {
      node.textContent = result;
    }
  }

  function getMapOfNodes(nodes) {
    return nodes.flatMap(tagName => Array.from(document.getElementsByTagName(tagName)));
  }

  function replacePrices() {
    let processedCount = 0;

    const textOnlyNodes = getMapOfNodes(TEXT_NODES_TO_CHECK);
    for (const node of textOnlyNodes) {
      if (!node.childNodes || node.childNodes.length === 0) continue;

      for (const textNode of node.childNodes) {
        if (textNode.nodeType !== Node.TEXT_NODE) continue;

        const originalText = textNode.textContent;
        replacePrice(textNode);
        if (textNode.textContent !== originalText) processedCount++;
      }
    }

    const otherNodes = getMapOfNodes(OTHER_NODES_TO_CHECK);
    for (const node of otherNodes) {
      if (
        node.childNodes &&
        node.childNodes.length === 1 &&
        node.childNodes[0].nodeType === Node.TEXT_NODE
      ) {
        const originalText = node.childNodes[0].textContent;
        replacePrice(node.childNodes[0]);
        if (node.childNodes[0].textContent !== originalText) processedCount++;
      }
    }

    if (processedCount > 0) {
      console.log(`Shopify EUR->BGN Converter RZ: Processed ${processedCount} price elements`);
    }
    return processedCount;
  }

  let observerTimeout;
  const observerCallback = () => {
    clearTimeout(observerTimeout);
    observerTimeout = setTimeout(() => replacePrices(), 250);
  };

  const init = () => {
    setTimeout(() => {
      replacePrices();
      console.log('Shopify EUR->BGN Converter RZ v7 initialized successfully');
    }, 100);

    if (window.MutationObserver) {
      const observer = new MutationObserver(observerCallback);
      observer.observe(document.body, { childList: true, subtree: true });

      window.EurBgnConverterShopify = {
        refresh: replacePrices,
        disconnect: () => {
          observer.disconnect();
          window.EurBgnConverterShopifyInitialized = false;
        },
        version: 'Shopify RZ v7.0 (EUR->BGN)'
      };
    }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
